var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var GalleryComponent = /** @class */ (function (_super) {
    __extends(GalleryComponent, _super);
    function GalleryComponent(injector) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.interiorImages = [
            { url: '/assets/images/gallery/interior/1.jpg' },
            { url: '/assets/images/gallery/interior/2.jpg' },
            { url: '/assets/images/gallery/interior/3.jpg' },
            { url: '/assets/images/gallery/interior/4.jpg' },
            { url: '/assets/images/gallery/interior/5.jpg' },
            { url: '/assets/images/gallery/interior/6.jpg' }
        ];
        _this.exteriorImages = [
            { url: '/assets/images/gallery/exterior/3.jpg' },
            { url: '/assets/images/gallery/exterior/4.jpg' },
            { url: '/assets/images/gallery/exterior/5.jpg' },
            { url: '/assets/images/gallery/exterior/6.jpg' },
            { url: '/assets/images/gallery/exterior/7.jpg' },
            { url: '/assets/images/gallery/exterior/8.jpg' },
            { url: '/assets/images/gallery/exterior/10.jpg' },
            { url: '/assets/images/gallery/exterior/11.jpg' }
        ];
        _this.apImages = [
            { url: '/assets/images/gallery/ap/1.jpg' },
            { url: '/assets/images/gallery/ap/2.jpg' },
            { url: '/assets/images/gallery/ap/3.jpg' },
            { url: '/assets/images/gallery/ap/4.jpg' },
            { url: '/assets/images/gallery/ap/5.jpg' },
            { url: '/assets/images/gallery/ap/6.jpg' },
            { url: '/assets/images/gallery/ap/7.jpg' },
            { url: '/assets/images/gallery/ap/8.jpg' },
            { url: '/assets/images/gallery/ap/10.jpg' },
            { url: '/assets/images/gallery/ap/12.jpg' },
            { url: '/assets/images/gallery/ap/13.jpg' },
            { url: '/assets/images/gallery/ap/14.jpg' },
            { url: '/assets/images/gallery/ap/15.jpg' },
            { url: '/assets/images/gallery/ap/16.jpg' },
            { url: '/assets/images/gallery/ap/17.jpg' },
            { url: '/assets/images/gallery/ap/18.jpg' },
            { url: '/assets/images/gallery/ap/19.jpg' },
            { url: '/assets/images/gallery/ap/20.jpg' },
            { url: '/assets/images/gallery/ap/21.jpg' },
            { url: '/assets/images/gallery/ap/22.jpg' },
            { url: '/assets/images/gallery/ap/23.jpg' },
            { url: '/assets/images/gallery/ap/24.jpg' },
            { url: '/assets/images/gallery/ap/25.jpg' },
            { url: '/assets/images/gallery/ap/26.jpg' },
            { url: '/assets/images/gallery/ap/27.jpg' },
            { url: '/assets/images/gallery/ap/28.jpg' },
            { url: '/assets/images/gallery/ap/29.jpg' },
            { url: '/assets/images/gallery/ap/30.jpg' }
        ];
        _this.interiorImages.forEach(function (image, index) {
            image.width_320_url = image.url;
            image.width_560_url = image.url;
        });
        _this.exteriorImages.forEach(function (image, index) {
            image.width_320_url = image.url;
            image.width_560_url = image.url;
        });
        _this.apImages.forEach(function (image, index) {
            image.width_320_url = image.url;
            image.width_560_url = image.url;
        });
        return _this;
    }
    GalleryComponent.prototype.ngOnInit = function () {
        this.setTitle('Viața ta la Romanescu Park Residence');
        this.setMetaDescription("\n      Iat\u0103 c\u00E2teva imagini care \u00EE\u021Bi arat\u0103 c\u00E2t de frumos va fi s\u0103 locuie\u0219ti la Romanescu Park Residence -\n      pentru c\u0103 e \u00EEntotdeauna minunat s\u0103 fii aproape de natur\u0103, \u00EEn mijlocul unui complex reziden\u021Bial\n      de calitate\n    ");
    };
    return GalleryComponent;
}(SeoAwareBaseComponent));
export { GalleryComponent };



// WEBPACK FOOTER //
// ./src/app/downtown-life/gallery.component.ts.pre-build-optimizer.js